<template>
  <section class="share-image">
    <img :src="image" class="thumbnail" @error="showError" />

    <div class="button-wrapper" v-if="share">
      <button class="button" @click="downloadImage">
        salvesta
      </button>
      <!-- <a class="button" download="tank-xmas-card.jpg" :href="image">download</a> -->
      <button class="button" @click="handleShare">
        jaga
      </button>
    </div>
    <div v-else style="text-align:center">
      <p>Nii jabur, et meeldib? Nii kole, et intrigeerib?</p>
      <p>Teeksid ise lõdvalt paremini?</p>
      <button @click="trackTryYourselfButton">proovi ka</button>
    </div>

    <fade-transition>
      <share-dialog v-show="showDialog" @action="showResetOverlay" @close="showResetOverlay" :cardUrl="image" />
    </fade-transition>

    <fade-transition>
      <section class="reset-wrapper" v-show="showResetMessage">
        <div class="scroll-cursor">
          <p class="intro">Lõbu ei pea siin veel lõppema!</p>
          <p class="intro">
            Lae üles ka mõne sõbra, kolleegi, pereliikme – või jumala eest, kasvõi lemmiklooma pilt ja üllata neidki!
          </p>
        </div>

        <div>
          <button @click="$emit('reset', true)">uuesti algusesse</button>
          <!-- <button @click="showResetMessage = false">jaga veel</button> -->
          <button @click="showResetMessage = false">tagasi minu kaardi juurde</button>
        </div>
      </section>
    </fade-transition>
  </section>
</template>

<script>
import { saveAs } from 'file-saver'
import { FadeTransition } from 'vue2-transitions'

import ShareDialog from '@/components/ShareDialog'

export default {
  name: 'share-image',
  data() {
    return {
      image: '',
      loading: true,
      showDialog: false,
      showResetMessage: false
    }
  },
  components: { ShareDialog, FadeTransition },
  props: {
    id: String,
    share: Boolean
    // finalImage: null
  },
  created() {
    this.loading = true
    if (!this.id) this.$router.replace('/')

    // TODO: Check if ID exists in Storage and display 404 otherwise?
    // console.info('cardRef', this.id)
    this.image = `https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/cards%2F${this.id}?alt=media`
    this.loading = false
  },
  methods: {
    async downloadImage() {
      // https://firebase.google.com/docs/storage/web/download-files
      const imageRef = this.$storage.refFromURL(this.image)
      const url = await imageRef.getDownloadURL()

      // This can be downloaded directly:
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function() {
        let blob = xhr.response
        blob = blob.slice(0, blob.size, 'image/jpeg')
        console.info('blob', blob)
        saveAs(blob, 'tank-xmas-card.jpg')
        window.gtag('event', 'image-downloaded')
      }
      xhr.open('GET', url)
      xhr.send()

      this.showResetMessage = true
    },
    handleShare() {
      const isSafari = window.safari && /.*Version.*Safari.*/.test(navigator.userAgent)
      console.info('Safari share API check', isSafari)

      if (!isSafari && navigator.share) {
        navigator
          .share({
            title: 'Tank Xmas 🎅',
            url: `https://xmas.tank.ee/card/${this.id}`
          })
          .catch(console.error)
        this.showResetOverlay()
        window.gtag('event', 'mobile-share')
      } else {
        this.showDialog = true
      }
    },
    showResetOverlay() {
      this.showDialog = false
      this.showResetMessage = true
    },
    showError() {
      console.info('Shared card does not exist!')
    },
    trackTryYourselfButton() {
      window.gtag('event', 'cta-proovi-ka-clicked')
      this.$emit('reset', false)
    }
  }
}
</script>

<style lang="scss">
.share-image {
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  height: 90vh;

  .thumbnail {
    max-width: 85vw;
    height: auto;
    margin-top: 5vh;
  }

  p {
    font-size: 1.4rem;
    font-weight: 500;
  }
  p:first-child {
    margin-top: 1rem;
  }

  .button-wrapper {
    margin-top: 1rem;
  }

  @media screen and (max-width: 50rem) {
    .thumbnail {
      max-width: 96vw;
    }
  }
}

.reset-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 4;
  overflow: auto;

  font-weight: 900;
  padding: 4rem 2em;
  background-color: rgb(148, 149, 136, 0.88);

  @media screen and (max-width: 55rem) {
    font-size: 0.75rem;
  }
  @media screen and (max-width: 40rem) {
    font-size: 0.35rem;
  }

  .content {
    width: 50rem;
    max-width: 95%;
    text-align: center;
  }

  .intro {
    margin: 3rem 0;
    font-size: 7em;
    font-weight: inherit;

    @media screen and (max-width: 40rem) {
      font-weight: 900;
    }
  }
  div:last-child {
    margin-bottom: 5rem;
    text-align: center;
  }
}
</style>
